module.exports = __webpack_public_path__ + "h5/img/questionPub.cc78639a.jpg";